import React from 'react';
import type { CriticalResultsCriticalitySummaryItem } from '../../types/criticalResultsDashboard.types';
import {
  formatCriticalityLabel,
  formatShortDuration,
  normalizeCriticalitySummary,
} from '../../utils/criticalResultsDashboardUtils';

interface CriticalResultsCriticalityPanelProps {
  items: CriticalResultsCriticalitySummaryItem[];
}

function badgeClass(band: string) {
  if (band === 'Major') {
    return 'crd-criticality-item crd-criticality-item--major';
  }
  if (band === 'Minor') {
    return 'crd-criticality-item crd-criticality-item--minor';
  }
  return 'crd-criticality-item';
}

export default function CriticalResultsCriticalityPanel({
  items,
}: Readonly<CriticalResultsCriticalityPanelProps>) {
  const displayItems = normalizeCriticalitySummary(items);

  return (
    <section className="crd-panel crd-criticality-panel">
      <header className="crd-panel-header">
        <h2 className="crd-panel-title">Criticality-wise summary</h2>
      </header>
      <ul className="crd-criticality-list">
        {displayItems.map(item => (
          <li
            key={item.criticalityBand}
            className={badgeClass(String(item.criticalityBand))}
          >
            <div className="crd-criticality-head">
              <span className="crd-criticality-badge">
                {formatCriticalityLabel(String(item.criticalityBand))}
              </span>
              <span className="crd-criticality-total">{item.total}</span>
            </div>
            <div className="crd-criticality-metrics">
              <span>Open {item.open}</span>
              <span>Acknowledged {item.acknowledged}</span>
              <span>Breaches {item.breaches}</span>
              <span>Avg TAT {formatShortDuration(item.averageTatSeconds)}</span>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
